import { render } from "./QuestionList.vue?vue&type=template&id=a96f7e54&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"

import "./QuestionList.vue?vue&type=style&index=0&id=a96f7e54&scoped=true&lang=scss"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96f7e54"]])

export default __exports__